import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IIceCatReportHaveNotUpdatedRequest } from '../models/models'

export class GetIceCatReportHaveNotUpdatedApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/icecat/GetIceCatReportHaveNotUpdated',
      requesterInfo,
    })
  }

  public async getIceCatReportHaveNotUpdated(request: IIceCatReportHaveNotUpdatedRequest): Promise<any[]> {
    return await this.postAsync<any[]>(request)
  }
}
